import { classNames } from '@dimjs/utils';
import { toArray } from '@flatbiz/utils';
import { cloneElement, CSSProperties, Fragment, ReactElement, ReactNode } from 'react';
import { CommonPropsWithChildren } from '../../utils';
import './style.less';

export type CssActiveProps = {
  children: ReactElement;
} & Pick<
  CommonPropsWithChildren<{
    '--v-css-active-bgcolor': CSSProperties['backgroundColor'];
    '--v-css-active-opacity': CSSProperties['opacity'];
  }>,
  'style' | 'children'
>;
/**
 * css active 效果
 * ```
 * 1. 当children为数组时，会为children添加父级（会产生新节点）
 * 2. 当children为单个元素时，会在children元素上添加className、style（不会产生新节点）
 * ```
 * @param props
 * @returns
 */
export const CssActive = (props: CssActiveProps) => {
  const children = toArray<ReactNode>(props.children);
  if (children.length > 1) {
    return (
      <div className="v-css-active" style={props.style}>
        {children}
      </div>
    );
  }

  return (
    <Fragment>
      {cloneElement(props.children, {
        className: classNames('v-css-active', props.children.props.className),
        style: { ...props.style, ...props.children.props.style },
      })}
    </Fragment>
  );
};
